import { FaSpinner } from 'react-icons/fa'
import RichTextEditor from '../../../core/components/UI/RichTextEditor'
import { toastSuccess } from '../../../helper'
import {
  useNavigate,
  useParams,
} from 'react-router-dom/dist/umd/react-router-dom.development'
import useMineralsActions from '../../hooks/useMineralsActions'
import { useRef } from 'react'

export default function FormEditMineralCountry({ details }) {
  const { mineral_id, country_id } = useParams()
  const navigate = useNavigate()
  const { updateMineralDetailsForCountry, inProgress } = useMineralsActions()

  const mineralCountryDescriptionArRef = useRef(null)
  const mineralCountryDescriptionEnRef = useRef(null)
  const mineralCountrySrouceArRef = useRef(null)
  const mineralCountrySrouceEnRef = useRef(null)

  async function handleOnSubmitCreateMineralDetailsForCountryForm(event) {
    event.preventDefault()
    const payload = {
      description_ar: mineralCountryDescriptionArRef.current.getContent(),
      description_en: mineralCountryDescriptionEnRef.current.getContent(),
      source_ar: mineralCountrySrouceArRef.current.getContent(),
      source_en: mineralCountrySrouceEnRef.current.getContent(),
    }

    const message = await updateMineralDetailsForCountry(
      mineral_id,
      country_id,
      payload,
    )

    if (message) {
      toastSuccess(message)
      navigate(`/minerals`)
    }
  }

  return (
    <form
      onSubmit={handleOnSubmitCreateMineralDetailsForCountryForm}
      className="flex flex-col gap-4"
    >
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COUNTRY_DESCRIPTION_AR"
        >
          وصف بالعربية <span className="text-danger-600">*</span>
        </label>
        <RichTextEditor
          onInit={(event, editor) =>
            (mineralCountryDescriptionArRef.current = editor)
          }
          defaultValue={details?.description_ar}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COUNTRY_DESCRIPTION_EN"
        >
          وصف بالإنجليزية
        </label>
        <RichTextEditor
          dir="ltr"
          onInit={(event, editor) =>
            (mineralCountryDescriptionEnRef.current = editor)
          }
          defaultValue={details?.description_en}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COUNTRY_HISTORY_AR"
        >
          مصدر بالعربية <span className="text-danger-600">*</span>
        </label>
        <RichTextEditor
          onInit={(event, editor) =>
            (mineralCountrySrouceArRef.current = editor)
          }
          defaultValue={details?.source_ar}
        />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COUNTRY_HISTORY_EN"
        >
          مصدر بالإنجليزية
        </label>
        <RichTextEditor
          dir="ltr"
          onInit={(event, editor) =>
            (mineralCountrySrouceEnRef.current = editor)
          }
          defaultValue={details?.source_en}
        />
      </div>
      <button
        type="submit"
        disabled={inProgress}
        className="flex w-full items-center justify-center gap-2 border-2 border-primary-600 bg-primary-600 px-6 py-3 font-bold text-white outline-none hover:border-accent-600 hover:bg-accent-600 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
      >
        {inProgress ? (
          <>
            <FaSpinner
              size={16}
              className="animate-spin"
            />
            <span>جاري تعديل معدن...</span>
          </>
        ) : (
          <span>تعديل معدن</span>
        )}
      </button>
    </form>
  )
}
